import { Link, useLocation } from 'react-router';
import { HomePage } from './HomePage';
import { HOME_TABS, tabFromPath } from './homeTabs';
import { MyTasksPage } from '../myTasks/MyTasksPage';
import { MyShiftPage } from '../shift/MyShiftPage';

/**
 * Home, in three tabs.
 *
 * My Tasks was a sidebar entry of its own until now. It is not a destination
 * in the way Projects or Files are — it is one of the things you check when
 * you sit down, which is what Home already is. Folding it in shortens the
 * sidebar by one permanent row and puts the two views people open together
 * next to each other.
 *
 * ── Links, not buttons ─────────────────────────────────────────────────────
 *
 * Each tab has its own URL. A tab strip built on useState cannot be sent to
 * somebody, cannot be bookmarked, loses its place on refresh, and makes Back
 * skip the whole section — and the old /my-tasks address, which is in
 * bookmarks and Slack messages, would have nowhere to land. One path per tab
 * costs nothing and fixes all of it.
 *
 * aria-current is set from the path rather than left to NavLink, because
 * NavLink treats /home as active while you are on /home/tasks — two tabs
 * marked current is worse than none.
 *
 * Panels are switched, not hidden. The inactive ones are not mounted, so the
 * dashboard's task and project queries do not run while somebody is reading
 * their notes.
 */
export function HomeSection() {
  const location = useLocation();
  const active = tabFromPath(location.pathname);

  return (
    <>
      <nav className="tracker-tab-nav" aria-label="Home sections">
        {HOME_TABS.map((tab) => (
          <Link
            key={tab.id}
            to={tab.path}
            className={`tracker-tab-button${tab.id === active ? ' tracker-tab-button--active' : ''}`}
            aria-current={tab.id === active ? 'page' : undefined}
          >
            {tab.label}
          </Link>
        ))}
      </nav>

      {active === 'overview' ? <HomePage /> : null}
      {active === 'tasks' ? <MyTasksPage /> : null}
      {active === 'shift' ? <MyShiftPage /> : null}
    </>
  );
}
